<template>
  <VueTelInput
    :value="formatedValue"
    :customValidate="customValidate"
    :validCharactersOnly="true"
    :inputOptions="{
      placeholder: placeholder,
      id: 'phone'
    }"
    :dropdownOptions="{
      showDialCodeInSelection: true,
      showDialCodeInList: true,
      showFlags: true,
    }"
    :default-country="formatedDefaultCountry"
    @input="(number, details) => $emit('input', { number, details })"
    @country-changed="(country) => $emit('country-changed', country)"
    :class="{ 'input-error': hasError }"
  />
</template>

<script>
import { VueTelInput } from 'vue-tel-input';
import 'vue-tel-input/dist/vue-tel-input.css';

export default {
  components: { VueTelInput },
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    customValidate: {
      type: [Boolean, RegExp],
      default: false,
    },
    placeholder: {
      type: String,
      default: '',
    },
    defaultCountry: {
      type: [String, Number]
    },
    hasError: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    formatedValue() {
      return this.value ? String(this.value) : '';
    },
    formatedDefaultCountry() {
      return Number(this.defaultCountry);
    }
  },
};
</script>

<style lang="scss" scoped>
@import '../../../sass/variables';
@import '../../../sass/mixins';

::v-deep.vue-tel-input {
  border: 1px solid $salesflow-outline-gray-light;
  border-radius: 12px;

  &:focus-within {
    box-shadow: none;
  }

  &.input-error {
    border-color: $salesflow-danger;
    
    .vti__input {
      &:focus {
        border-top: none;
        border-bottom: none;
        border-right: none;
        border-left: 1px solid $salesflow-outline-gray-light;
      }
    }
  }

  .vti__dropdown {
    background: white;
    padding: 0.625rem 0.75rem;
    border-top-left-radius: 12px;
    border-bottom-left-radius: 12px;

    &:hover {
      background: white;
    }

    .vti__dropdown-list {
      width: 250px;
      padding: 0.5rem 0rem;
      border: 1px solid $salesflow-outline-gray-light;
      border-radius: 12px;
      background: white;
      box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.08);
      top: 48px;
      z-index: 5;

      .vti__dropdown-item {
        padding: 0.25rem 1rem;

        @include salesflow-subtitle($color: $salesflow-font-dark);
        font-family: 'Inter';

        .vti__flag-wrapper {
          display: none;
        }

        strong {
          font-weight: 400;
        }

        span {
          color: $salesflow-font-gray-light;
        }
      }
    }
  }

  .vti__flag {
    margin: 0px;
  }

  .vti__country-code {
    @include salesflow-subtitle($color: $salesflow-font-dark);
    margin: 0px;
    line-height: 150%;
    font-family: 'Inter';
    margin-left: 0.25rem;
    margin-right: 0.25rem;
  }

  .vti__input {
    @include salesflow-subtitle($color: $salesflow-font-dark);
    line-height: 150%;
    font-family: 'Inter';
    border-top-right-radius: 12px;
    border-bottom-right-radius: 12px;

    border-left-width: 1px;
    border-left-style: solid;
    border-left-color: $salesflow-outline-gray-light;

    &:focus {
      border: 2px solid $salesflow-primary;
      border-left-width: 2px;
      border-left-style: solid;
      border-left-color: $salesflow-primary;
    }
  }
}
</style>
